import Tracker from "./Tracker";

class NoopTracker extends Tracker {
  logEvent() {}

}

export default NoopTracker;